<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { TYPE_CODES } from '@/modules/transactions/_constants/constants'

export default {
  name: 'ExportIndex',
  computed: {
    exportationFlow () {
      return this.$store.getters['ExportStore/exportationFlow']
    },
    exportationFlows () {
      return this.$store.getters['ExportStore/exportationFlows']
    }
  },
  methods: {
    _manageRoute () {
      if (this.exportationFlows.length === 0) {
        return this.$router.push('/export/create')
      } else if (this.exportationFlow?.filters?.filter['type.code']?.includes(TYPE_CODES.EXPENSE) && this.$route.name !== 'export_exported') {
        return this.$router.push('/export/expenses')
      } else if (this.exportationFlow?.filters?.filter['type.code']?.includes(TYPE_CODES.NORMAL) && this.$route.name !== 'export_exported') {
        return this.$router.push('/export/transactions')
      } else {
        return this.$router.push('/export/all')
      }
    }
  },
  watch: {
    async $route () {
      if (this.$route.name !== 'export') return
      await this.$store.dispatch('ExportStore/fetchExportationFlows', false).then(async () => {
        let exportationFlows = this.$store.getters['ExportStore/exportationFlows']
        if (exportationFlows.length > 0) {
          await this.$store.dispatch('ExportStore/fetchExportationFlow', exportationFlows[0].id)
        }
      })
      this._manageRoute()
    }
  },
  created () {
    this._manageRoute()
  }

}
</script>
